/* LNGVTY "I'm not like other serums" landing page (lpm-*).
   Safe to load more than once: every element is initialised a single time.
   Buy now buttons are never referenced directly because GoKwik replaces them with clones;
   the variant always travels in the hidden input[name="id"] of the button's /cart/add form. */
(function () {
  if (window.__lpmLoaded) { if (window.__lpmInit) window.__lpmInit(document); return; }
  window.__lpmLoaded = true;

  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  var toastEl, toastTimer;
  function say(msg) {
    toastEl = toastEl || document.querySelector('[data-lpm-toast]');
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  function pop(b) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }

  function initHearts(root) {
    root.querySelectorAll('.lpm .heart').forEach(function (b) {
      if (!once(b, 'lpmHeart')) return;
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on);
        if (on) {
          pop(b);
          var n = document.querySelectorAll('.lpm .heart[aria-pressed="true"]').length;
          say(n === 1 ? 'Liked. Keep going.' : n + ' likes. Sounds like a match.');
        }
      });
    });
    root.querySelectorAll('.lpm .rh, .lpm .fh-white').forEach(function (b) {
      if (!once(b, 'lpmHeart')) return;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on);
        if (on) pop(b);
      });
    });
    root.querySelectorAll('.lpm .i-list li').forEach(function (li) {
      if (!once(li, 'lpmRow')) return;
      li.addEventListener('click', function () { var b = li.querySelector('.rh'); if (b) b.click(); });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('.lpm [data-car]').forEach(function (c) {
      if (!once(c, 'lpmCar')) return;
      var t = c.querySelector('[data-track]'); if (!t) return;
      var pv = c.querySelector('.prev'), nx = c.querySelector('.next');
      function size() {
        if (t.dataset.step === 'page') return t.clientWidth * 0.7;
        var f = t.firstElementChild; if (!f) return t.clientWidth;
        var g = parseFloat(getComputedStyle(t).columnGap) || 10;
        return f.getBoundingClientRect().width + g;
      }
      function step(d) { t.scrollBy({ left: d * size(), behavior: 'smooth' }); }
      function upd() {
        if (pv) pv.disabled = t.scrollLeft < 8;
        if (nx) nx.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 8;
      }
      if (pv) pv.addEventListener('click', function () { step(-1); });
      if (nx) nx.addEventListener('click', function () { step(1); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      var down = false, sx = 0, sl = 0, moved = 0;
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.target.closest('button,a,input')) return;
        down = true; moved = 0; sx = e.clientX; sl = t.scrollLeft; t.classList.add('dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); t.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false; t.classList.remove('dragging');
        if (t.dataset.step !== 'page') { var w = size(); t.scrollTo({ left: Math.round(t.scrollLeft / w) * w, behavior: 'smooth' }); }
      });
      t.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    });
  }

  function setSoldOut(card, out) {
    card.querySelectorAll('.pb-add, .pb-buy').forEach(function (b) {
      b.disabled = out;
      if (b.classList.contains('pb-add')) b.textContent = out ? 'Sold out' : (b.dataset.label || 'Add to cart');
    });
  }

  function initSerumCards(root) {
    root.querySelectorAll('.lpm .pcard').forEach(function (card) {
      if (!once(card, 'lpmCard')) return;
      var add = card.querySelector('.pb-add');
      if (add) add.dataset.label = add.textContent.trim();
      card.querySelectorAll('.sz').forEach(function (x) {
        x.addEventListener('click', function () {
          card.querySelectorAll('.sz').forEach(function (o) { o.setAttribute('aria-checked', o === x); });
          var id = x.dataset.id;
          card.dataset.variant = id;
          var input = card.querySelector('form input[name="id"]'); if (input) input.value = id;
          var p = card.querySelector('.pprice .pp-price'); if (p) p.textContent = x.dataset.price;
          var s = card.querySelector('.pprice .pp-compare'); if (s) s.textContent = x.dataset.compare || '';
          var o = card.querySelector('.pprice .pp-off'); if (o) o.textContent = x.dataset.off || '';
          setSoldOut(card, x.dataset.available === '0');
        });
      });
      if (add) add.addEventListener('click', function () { addToCart(card.dataset.variant, add); });
    });
  }

  function addToCart(id, btn) {
    if (!id) return;
    var label = btn.dataset.label || btn.textContent;
    btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        btn.disabled = false;
        if (drawer && res.sections) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            return;
          } catch (e) {}
        }
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; }, 1500);
        say('Added to your bag.');
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        say((err && err.description) || 'Could not add. Please try again.');
      });
  }

  function initBuyCards(root) {
    root.querySelectorAll('.lpm .match').forEach(function (m) {
      if (!once(m, 'lpmMatch')) return;
      var ps = m.querySelectorAll('.pick');
      ps.forEach(function (b) {
        b.addEventListener('click', function () {
          ps.forEach(function (o) { o.setAttribute('aria-checked', o === b); });
          var input = m.querySelector('form input[name="id"]'); if (input) input.value = b.dataset.id;
          var pn = m.querySelector('.pn'); if (pn) pn.textContent = b.dataset.name;
          var pv = m.querySelector('.price-sel [data-price]'); if (pv) pv.textContent = b.dataset.price;
          var pc = m.querySelector('.price-sel [data-compare]'); if (pc) pc.textContent = b.dataset.compare || '';
        });
      });
    });
  }

  function initBar(root) {
    var bar = document.querySelector('.lpm [data-lpm-bar]');
    if (!bar || !once(bar, 'lpmBar')) return;
    var pass = bar.querySelector('[data-lpm-pass]');
    var sheet = document.querySelector('.lpm [data-lpm-sheet]');
    if (pass && sheet && typeof sheet.showModal === 'function') {
      pass.addEventListener('click', function () { sheet.showModal(); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      sheet.querySelectorAll('[data-lpm-close]').forEach(function (b) { b.addEventListener('click', function () { sheet.close(); }); });
    }
    function sync() {
      var on = !bar.classList.contains('hide') && getComputedStyle(bar).display !== 'none';
      document.documentElement.classList.toggle('lpm-bar-on', on);
    }
    if ('IntersectionObserver' in window) {
      var seen = new Set();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        bar.classList.toggle('hide', seen.size > 0); sync();
      }, { threshold: 0.05 });
      document.querySelectorAll('.lpm-intro, .lpm [data-lpm-buy-inline], footer, .footer').forEach(function (el) { io.observe(el); });
    } else { bar.classList.remove('hide'); }
    window.addEventListener('resize', sync); sync();
  }

  function init(root) {
    root = root || document;
    initHearts(root); initCarousels(root); initSerumCards(root); initBuyCards(root); initBar(root);
  }
  window.__lpmInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
